import { inject, Injectable } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { IMatIconRegister } from '@shared/interfaces/mat-icon-register.interface';

@Injectable()
export class MatIconRegistryService {
  private matIconRegistry: MatIconRegistry = inject(MatIconRegistry);
  private domSanitizer: DomSanitizer = inject(DomSanitizer);

  public customSvgIconList: IMatIconRegister[] = [
    {
      iconUrl: 'assets/custom-icons/settings.svg',
      iconLabel: 'settings',
    },
    {
      iconUrl: 'assets/custom-icons/meter-icon.svg',
      iconLabel: 'meter-icon',
    },
    {
      iconUrl: 'assets/custom-icons/configurator-metabolic-fingerprint.svg',
      iconLabel: 'configurator-metabolic-fingerprint',
    },
    {
      iconUrl: 'assets/custom-icons/unlock.svg',
      iconLabel: 'unlock',
    },
    {
      iconUrl: 'assets/custom-icons/lock.svg',
      iconLabel: 'lock',
    },
    {
      iconUrl: 'assets/custom-icons/success-smile.svg',
      iconLabel: 'success-smile',
    },
    {
      iconUrl: 'assets/custom-icons/warning-smile.svg',
      iconLabel: 'warning-smile',
    },
    {
      iconUrl: 'assets/custom-icons/error-smile.svg',
      iconLabel: 'error-smile',
    },
    {
      iconUrl: 'assets/custom-icons/certificate.svg',
      iconLabel: 'certificate',
    },
    {
      iconUrl: 'assets/custom-icons/badge.svg',
      iconLabel: 'badge',
    },
  ];

  public registerCustomMatIcon(label: string, url: string): void {
    this.matIconRegistry.addSvgIcon(label, this.sanitizeSvgIconUrl(url));
  }

  private sanitizeSvgIconUrl(url: string): SafeResourceUrl {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
  }

  public getCustomSvgIconList(): IMatIconRegister[] {
    return this.customSvgIconList;
  }
}
